<template>
  <v-card
    :flat="!$vuetify.breakpoint.smAndUp"
    class="mb-3"
  >
    <v-card-title
      :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''"
    >
      Kit Rental Rate
    </v-card-title>
    <v-card-text :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
      <v-row
        wrap
        no-gutters
      >
        <v-col
          cols="12"
          class="my-0"
        >
          <v-checkbox
            :value="addKitRental"
            label="Add Kit Rental"
            data-cy="kit-rental-checkbox-add"
            @change="() => {
              $emit('input',{
                ...value,
                kitRental : {
                  ...value.kitRental,
                  addKitRental: !value.kitRental.addKitRental
                }
              })
            }"
          />
        </v-col>
        <v-expand-transition>
          <v-col
            v-if="addKitRental"
            cols="12"
            class="my-0"
          >
            <v-row
              no-gutters
              wrap
              justify="start"
            >
              <v-col cols="6">
                <v-text-field
                  :value="kitRental.rate"
                  type="number"
                  pattern="\d*"
                  :rules="[rules.required]"
                  label="Rental Rate*"
                  class="mr-2"
                  prefix="$"
                  data-cy="kit-rental-rate"
                  @input="(val) => {
                    $emit('input',{
                      ...value,
                      kitRental : {
                        ...value.kitRental,
                        rate: val
                      }
                    })
                  }"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-expand-transition>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon';
import FileUploader from './FileUploader.vue';

export default {
  components: {
    FileUploader,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    date: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || 'Required.',
        counter: (value) => (!value || value?.length <= 60) || 'Max 60 characters',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
      },
    };
  },
  computed: {
    kitRental() {
      return this.value?.kitRental;
    },
    addKitRental() {
      return this.kitRental?.addKitRental;
    },
    uploadKitRentalInventory() {
      return this.kitRental?.uploadKitRentalInventory;
    },
    mileageForm() {
      return this.value?.mileageForm;
    },
    addMileageForm() {
      return this.mileageForm?.addMileageForm;
    },
    daysSelected() {
      return this.value.times.filter((time) => time.workedToday);
    },
  },
  methods: {
    setChargeKitRental(day) {
      const newVal = JSON.parse(JSON.stringify(this.value));
      const newDay = newVal.times.find((time) => time.dayOfWeek === day.dayOfWeek);
      newDay.chargeKitRental = !newDay.chargeKitRental;
      this.$emit('input', newVal);
    },
    getChargeKitDayLabel(date) {
      const formattedDate = DateTime.fromISO(date).toFormat(this.date ? 'ccc (MM/d)' : 'ccc');
      return `${formattedDate}`;
    },
    addInventoryItem() {
      this.$emit('input', {
        ...this.value,
        kitRental: {
          ...this.value.kitRental,
          inventoryList: [...this.kitRental.inventoryList].concat([{}]),
        },
      });
    },
    removeInventoryItem(index) {
      const newList = [...this.kitRental.inventoryList];
      newList.splice(index, 1);
      this.$emit('input', {
        ...this.value,
        kitRental: {
          ...this.value.kitRental,
          inventoryList: newList,
        },
      });
    },
    updateInventoryItemDescription(index, description) {
      const newList = [...this.kitRental.inventoryList];
      newList[index].description = description;
      this.$emit('input', {
        ...this.value,
        kitRental: {
          ...this.value.kitRental,
          inventoryList: newList,
        },
      });
    },
    updateInventoryItemPrice(index, price) {
      const newList = [...this.kitRental.inventoryList];
      newList[index].price = price;
      this.$emit('input', {
        ...this.value,
        kitRental: {
          ...this.value.kitRental,
          inventoryList: newList,
        },
      });
    },
  },
};
</script>
